<template>
  <!-- Component Select Lesson and Show Progressbar-->
  <CRow style="padding-top: 100px; min-height: 600px">
    <CCol col="2" style="display: flex; justify-content: center">
      <ScrollBar :checkPoints="2" @returnAction="returnAction" />
    </CCol>
    <CCol col="10">
      <div class="scroll-custom-container">
        <vue-scroll-snap :fullscreen="true">
          <div class="itemA"><SwiperItem :items="imgData" /></div>
          <div class="itemB">
            <CRow
              alignHorizontal="center"
              style="margin: auto; display: flex; align-items: center"
            >
              <CCol v-for="(item, index) in buttonsData" :key="index">
                <Buttons
                  :text="item.text"
                  :imgUrl="item.iconUrl"
                  :alignText="item.alignStyle"
                />
              </CCol>
            </CRow>
          </div>
        </vue-scroll-snap>
      </div>
      <!-- Component Select Type of Lesson-->
      <!-- <template>
      <CRow
        alignHorizontal="center"
        style="margin: auto; display: flex; align-items: center"
      >
        <CCol v-for="(item, index) in buttonsData" :key="index">
          <Buttons
            :text="item.text"
            :imgUrl="item.iconUrl"
            :alignText="item.alignStyle"
          />
        </CCol>
      </CRow>
    </template> -->
    </CCol>
  </CRow>
</template>

<script>
import { mapGetters } from "vuex";
import "../../assets/scss/_chineseStyle.scss";
import SwiperItem from "../../components/elements/SwiperItem";
import ScrollBar from "../../components/elements/ScrollBar";
import Buttons from "../../components/elements/Buttons/Button";
import VueScrollSnap from "vue-scroll-snap";

export default {
  name: "LS01",
  components: {
    SwiperItem,
    ScrollBar,
    Buttons,
    VueScrollSnap,
  },
  props: {
    id: String,
  },
  data() {
    return {
      buttonsData: [
        {
          iconUrl:
            "https://cdn2.iconfinder.com/data/icons/iconfinder-logo/69/eye_black-512.png",
          text: [
            {
              key: "en",
              val: "VOCABULARY",
            },
            {
              key: "th",
              val: "รวมคำศัพท์",
            },
            {
              key: "cn",
              val: "VOCABULARY",
            },
          ],
          alignText: "right",
        },
        {
          iconUrl: "https://simpleicon.com/wp-content/uploads/rocket.png",
          text: [
            {
              key: "en",
              val: "NOTE",
            },
            {
              key: "th",
              val: "รวมความรู้",
            },
            {
              key: "cn",
              val: "NOTE",
            },
          ],
          alignText: "right",
        },
        {
          iconUrl:
            "https://upload.wikimedia.org/wikipedia/en/thumb/e/e0/WPVG_icon_2016.svg/1024px-WPVG_icon_2016.svg.png",
          text: [
            {
              key: "en",
              val: "TEST",
            },
            {
              key: "th",
              val: "ทดสอบ",
            },
            {
              key: "cn",
              val: "TEST",
            },
          ],
          alignText: "right",
        },
      ],
      imgData: [
        {
          id: 1,
          name: "LESSON 1",
          nameofles: "Medical Care",
          img: "https://www.flaticon.com/svg/static/icons/svg/4006/4006394.svg",
        },
        {
          id: 2,
          name: "LESSON 2",
          nameofles: "Medical Team",
          img: "https://www.flaticon.com/svg/static/icons/svg/4006/4006408.svg",
        },
        {
          id: 3,
          name: "LESSON 3",
          nameofles: "Medical Term",
          img: "https://www.flaticon.com/svg/static/icons/svg/4006/4006414.svg",
        },
        {
          id: 4,
          name: "LESSON 4",
          nameofles: "Medival",
          img: "https://www.flaticon.com/svg/static/icons/svg/4006/4006419.svg",
        },
        {
          id: 5,
          name: "LESSON 5",
          nameofles: "Medical Push",
          img: "https://www.flaticon.com/svg/static/icons/svg/4006/4006423.svg",
        },
        {
          id: 6,
          name: "LESSON 6",
          nameofles: "Medical",
          img: "https://www.flaticon.com/svg/static/icons/svg/4006/4006431.svg",
        },
      ],
      hover: false,
      preTest: false,
      lang: "",
      content: {},
      baseUrl: "",
      counter: 86,
      CheckWidth: window.innerWidth,
      progress: {},
      progress2: {},
      warningModal: false,
      openPostTest: false,
      postTest: false,
      courseSection: "",
      startTime: "",
      courseCode: "",
      allChapter: [],
    };
  },
  computed: {
    ...mapGetters({
      allCourse: "template/getTemplateContent",
      storeLanguage: "language/getLanguage",
      progressData: "template/getProgressData",
      getCourseChapterAndProgress: "courses/getCourseChapterAndProgress",
      getLessonActive: "necessary/getLessonActive",
    }),
  },

  watch: {},
  created() {},
  mounted() {
    window.onscroll = function () {
      scrollFunction();
    };

    function scrollFunction() {
      console.log("scrollTop", document.body.scrollTop);
      console.log("documentElement", document.documentElement.scrollTop);
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        console.log("scroll! down");
      } else {
        console.log("scroll! up");
      }
    }
  },
  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
    },
    returnAction(val) {},
  },
};
</script>

<style scoped lang="scss">
.scroll-custom-container {
  height: 500px !important;
  width: 300px !important;
  background: darkgoldenrod;
  overflow: scroll;
}
.scroll-snap-container {
  height: auto  !important;
  width: auto !important;
}
.itemA {
  min-height: 500px;
  height: auto;
  background-color: lightblue;
  display: flex;
  align-items: center;
  justify-content: center;
}
.itemB {
  min-height: 500px;
  height: auto;
  background-color: pink;
  display: flex;
  align-items: center;
  justify-content: center;
}
.scroll-snap-container {
  height: 500px;
  width: 500px;
}
.LS01_background {
  background-color: #e6efff;
}
</style>